import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { confirmationStyle } from './style';

export const ContactDetailsConfirmationMessage = (): JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <>
      <Typography sx={ confirmationStyle.header.sx } style={ confirmationStyle.header.style }>
        {translate(STRING_KEYS.UPDATE_MESSAGE)}
      </Typography>
      <Typography sx={ confirmationStyle.subHeader.sx } style={ confirmationStyle.subHeader.style }>
        {translate(STRING_KEYS.NOTIFICATION_MESSAGE)}
      </Typography>
    </>
  );
};
